/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SSOWrapper } from "../sso-components/sso-dynamic";

export const UserLogin = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: "OPEN_LOGIN_TEMPLATE" });
  }, []);

  return <SSOWrapper />;
};
